export default  string => `${string}s`
